import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db6d118c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "empty-state-panel" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}




export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyStatePanel',
  props: {
    icon: {},
    title: {},
    description: {},
    buttonText: {},
    loading: { type: Boolean },
    loadingText: {}
  },
  emits: ["action"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: _normalizeClass(_ctx.icon)
    }, null, 2),
    _createElementVNode("h5", null, _toDisplayString(_ctx.title), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.description), 1),
    (_ctx.buttonText)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('action'))),
          disabled: _ctx.loading
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.loading ? _ctx.loadingText || "Loading..." : _ctx.buttonText), 1)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})